import { render } from "./ConsentModal.vue?vue&type=template&id=780da8c0&scoped=true"
import script from "./ConsentModal.vue?vue&type=script&lang=js"
export * from "./ConsentModal.vue?vue&type=script&lang=js"

import "./ConsentModal.vue?vue&type=style&index=0&id=780da8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780da8c0"]])

export default __exports__